import { ClassificationModel } from '@microsoft/customvision-tfjs';
import { concatMap, filter, forkJoin, from, map, mapTo, Observable, of, switchMap, tap } from 'rxjs';
import { MSModel } from '../../Utils/Types';
import { ImageClassifier } from './ImageClassifier';
import { ImageClassifierPrediction } from './Models/ImageClassifierPrediction';

export class TensorFlowImageClassifier<T> implements ImageClassifier<T> {
  private model: MSModel;
  private labels: string[];

  public constructor(private path: string) {
    this.path = process.env.PUBLIC_URL + path;
    this.labels = [];
  }

  public load(): Observable<boolean> {
    return forkJoin([this.getLabels(), this.getModel()]).pipe(mapTo(true));
  }

  public predict(image: HTMLImageElement): Observable<T> {
    return from(this.model.executeAsync(image)).pipe(
      map((confidences) => new ImageClassifierPrediction(this.labels, (confidences as number[][])[0])),
      map((prediction) => prediction.highest),
      filter((prediction) => prediction.confidence > 0.7),
      map((prediction) => prediction.label as unknown as T)
    );
  }

  private getLabels(): Observable<string[]> {
    return from(fetch(this.path + '/labels.txt')).pipe(
      switchMap((file) => file.text()),
      map((text) => text.split('\n')),
      tap((labels) => (this.labels = labels))
    );
  }

  private getModel(): Observable<MSModel> {
    return of(new ClassificationModel()).pipe(
      concatMap((model) => from(model.loadModelAsync(this.path + '/model.json')).pipe(mapTo(model))),
      tap((model) => (this.model = model))
    );
  }
}
